<template>
  <div class="demo-page">
    <banner nav-public></banner>
    <!-- todo: remove notranslate once Transifex live is no longer used -->
    <main class="content notranslate">
      <h1 v-if="willRedirect" v-t>Redirecting...</h1>
      <div v-if="!willRedirect" class="copywriting-container">
        <h3 class="title full" v-t>Welcome to our Demo Portal</h3>
        <button-loader class="button-loader" @click="beginDemo" :is-loading="isLoadingDemoUser">
          <span slot="content" v-t>Begin Demo</span>
          <loader-copy slot="loading-text" class="loader-copy" v-bind:copywriting="loadingTextList" />
        </button-loader>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      <div v-if="!willRedirect" class="image-positioning-container">
        <img src="@theme/images/demo/demopage-begin-demo-illustration.jpg" class="demopage-begin-demo-illustration" />
      </div>
    </main>
    <router-view></router-view>
  </div>
</template>

<script>
import Banner from '@layoutTheme/banner';
import { http } from '~vue/helpers/http';
import ButtonLoader from '~vue/components/button-loader';
import LoaderCopy from './components/loader-copy';

export default {
  components: {
    Banner,
    ButtonLoader,
    LoaderCopy,
  },
  data() {
    return {
      isLoadingDemoUser: false,
      willRedirect: false,
      errorMessage: null,
      defaultErrorMessage: this.$t("Sorry something went wrong. We're looking into it."),
      loginAttemptsCount: 0,
      loadingTextList: [
        this.$t("Simulating account activity..."),
        this.$t("Quite a lot of account activity actually..."),
        this.$t("Creating some financial plans..."),
        this.$t("Now just a moment while we calculate future values for the S&P500..."),
        this.$t("Just kidding, we can't predict the future..."),
        this.$t("Yet..."),
        this.$t("Sorry this is taking so long, the hamster fell out of the wheel..."),
        this.$t("Got him!"),
        this.$t("Ok, any moment now..."),
      ]
    };
  },

  methods: {
    async beginDemo() {
      this.resetComponentState();
      const jobID = await this.createDemoUser();
      this.tryToLoginDemoUser(jobID);
    },
    resetComponentState() {
      this.errorMessage = null;
      this.isLoadingDemoUser = true;
      this.willRedirect = false;
    },
    async createDemoUser() {
      let jobID;
      try {
        const payload = this.generatePayloadForAPIRequest();
        const result = await http.post('/api/users/demo', payload);
        jobID = result.data;
      } catch (error) {
        console.error("Sorry something went wrong. We're looking into it.");
        this.resetStateAfterAPIResponse(this.defaultErrorMessage);
      }

      return jobID;
    },
    generatePayloadForAPIRequest() {
      const first_name = this.$route.query.first_name;
      const last_name = this.$route.query.last_name;
      return first_name && last_name ? { first_name, last_name } : {};
    },
    resetStateAfterAPIResponse(message) {
      this.isLoadingDemoUser = false;
      this.loginAttemptsCount = 0;
      if (message) {
        this.errorMessage = message;
      } else {
        this.willRedirect = true;
      }
    },
    tryToLoginDemoUser(jobID) {
      const loginProcess = setInterval(async () => {
        this.loginAttemptsCount++;

        let loginProcessStatus;
        try {
          const result = await http.get('/api/users/demo_login', { params: jobID });
          loginProcessStatus = result.data.status;
        } catch (error) {
          console.error("Error: could not login demo user.");
          this.resetStateAfterAPIResponse(this.defaultErrorMessage);
        }

        this.handleLoginDemoUserAPIResponse(loginProcess, loginProcessStatus);
      }, 2000);
    },
    handleLoginDemoUserAPIResponse(loginProcess, loginProcessStatus) {
      if (loginProcessStatus === 'complete') {
        clearInterval(loginProcess);
        this.resetStateAfterAPIResponse();
        window.location = '/app/dashboard';
      } else if (loginProcessStatus === 'failed') {
        clearInterval(loginProcess);
        console.error("Error: '/api/users/demo_login' returned with a 'failed' status.");
        this.resetStateAfterAPIResponse(this.defaultErrorMessage);
      }

      if (this.loginAttemptsCount >= 300) {
        clearInterval(loginProcess);
        console.error('Error: timeout, taking too long to login.');
        this.resetStateAfterAPIResponse(this.defaultErrorMessage);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .demo-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-items: center;
  }

  .content {
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    flex: 1 0 auto;
  }

  .copywriting-container {
    max-width: 22rem;
    margin-right: 0;
  }

  .button-loader {
    margin: 2rem 0;
  }

  .loader-copy {
    margin: 2rem 0 1rem;
  }

  .error-message {
    margin: 1rem 0 0 0;
    color: $ruby-700;
  }

  .demopage-begin-demo-illustration {
    max-width: 22rem;
    left: 1rem;
  }

  @media #{$screen-width-medium} {
    .content {
      flex-direction: row;
    }

    .copywriting-container {
      margin-right: 2rem;
    }

    .title {
      max-width: 100%;
    }

    .demopage-begin-demo-illustration {
      left: 0;
    }
  }
</style>
